export default __webpack_public_path__ + "static/media/logo-colorfol--matriciel.ef24e427.png";